import { useAppSelector } from 'hooks/useAppSelector';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { createSelector } from 'reselect';
import {
  getFormEnrichedData,
  getFormInputData,
  getFormPendingEnrichmentData,
  isPendingEnrichment,
} from 'state/selectors';
import { AppState } from 'state/state.model';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export interface FormGlobalInfo {
  clientId?: string;
  isLoading: boolean;
  instrumentName?: string;
  instrumentContractName?: string;
  productSubtype?: string;
  productType?: string;
  wrapper?: string;
}

const selectFormGlobalInfo = createSelector(
  [
    (state: AppState, formId: string) => getFormEnrichedData(state, formId),
    (state: AppState, formId: string) => getFormInputData(state, formId),
    (state: AppState, formId: string) => getFormPendingEnrichmentData(state, formId),
    (state: AppState, formId: string) => getWorkspaceType(state, formId),
    (state: AppState, formId: string) => isPendingEnrichment(state, formId),
  ],
  (enrichedData, inputData, pendingEnrichmentData, workspace, loading): FormGlobalInfo => {
    const data = { ...enrichedData, ...pendingEnrichmentData, ...inputData };
    const client = data.SelectedOnBehalfClient as ISalesCounterpart | undefined;
    return {
      isLoading: loading,
      clientId: client?.id as string,
      productType: workspace !== 'dynamic' ? (data.ProductType as string) : undefined,
      productSubtype: workspace !== 'dynamic' ? (data.ProductSubtype as string) : undefined,
      wrapper: data.Wrapper as string,
      instrumentName: workspace === 'dynamic' ? (data.ProductType as string) : undefined,
      instrumentContractName: workspace === 'dynamic' ? (data.ProductSubtype as string) : undefined,
    };
  },
);

export function useFormGlobalInfo(formId: string): FormGlobalInfo {
  return useAppSelector(state => selectFormGlobalInfo(state, formId));
}
